import React, { FC } from 'react'

import { Colors } from 'common-constants/colors'

export const HeartSvg: FC<{
  fill?: string
  size?: number
  stroke?: string
}> = ({ fill = 'none', size = 24, stroke = Colors.transparentFull }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9379 5.53854C12.9423 4.01327 15.1267 3 17.1553 3C20.2951 3 22.9746 5.48686 22.9746 8.47497C22.9746 8.47497 24.0003 14.4384 13.015 20.6616C12.8526 20.7536 12.4217 20.995 12 20.9999C11.5872 21.0046 11.1835 20.7747 11.0321 20.6892C-0.0047369 14.456 1.0255 8.47497 1.0255 8.47497C1.0255 5.48686 3.70671 3 6.84323 3C8.87173 3 10.9335 4.01327 11.9379 5.53854H12.3403H11.9379Z"
      fill={fill}
      stroke={stroke}
    />
  </svg>
)
